import { Link } from 'react-router-dom';
import type { ArticleSummary } from '../../../shared/types.ts';

const CAT_LABEL: Record<string, string> = {
  tutorial: 'Tutorial',
  project: 'Project',
  curiosity: 'Curiosity',
  qa: 'Q&A',
  cheatsheet: 'Cheatsheet',
  library: 'Library',
};

export function ArticleCard({ a }: { a: ArticleSummary }): JSX.Element {
  return (
    <Link to={`/a/${a.slug}`} className={`article-card cat-${a.category}`}>
      <div className="meta">
        <span className="badge">{CAT_LABEL[a.category]}</span>
        <span>·</span>
        <span>{a.difficulty}</span>
        <span>·</span>
        <span>{a.reading_minutes} min</span>
      </div>
      <h3>{a.title}</h3>
      <p>{a.description}</p>
      {a.tags.length > 0 && (
        <div className="foot">
          {a.tags.slice(0, 4).map(t => <span key={t}>#{t}</span>)}
        </div>
      )}
    </Link>
  );
}
